import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Injector,
  runInInjectionContext,
  signal,
} from '@angular/core';
import {
  retriveCurrentRouteData,
  SiaNewRouterService,
  SiaRouteData,
} from '@sia/shared';
import { SiaMatGridComponent } from '../../components/sia-mat-grid/sia-mat-grid.component';

@Component({
  selector: 'sia-mat-grid-page',
  templateUrl: './sia-mat-grid-page.component.html',
  styleUrls: ['./sia-mat-grid-page.component.scss'],
  standalone: true,
  imports: [SiaMatGridComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaMatGridPageComponent {
  private siaRouterService = inject(SiaNewRouterService);
  private injector = inject(Injector);
  #destroyRef = inject(DestroyRef);

  pageData = signal<SiaRouteData>({});

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  ngOnDestroy(): void {}

  ngOnInit() {
    let routeChanged = this.siaRouterService.routeChanged$.subscribe(() => {
      runInInjectionContext(this.injector, () => {
        var pageData = retriveCurrentRouteData();
        if (pageData?.guid !== this.pageData()?.guid) {
          this.pageData?.set({ ...pageData });
        }
      });
    });
    this.#destroyRef.onDestroy(() => {
      routeChanged?.unsubscribe();
    });
  }
}
